import { useProProfile } from "api/queries/pros";
import { PROfileSkills, PROfileSkillsSkeleton } from "domains/pros/components/PROfileSkills";
import type React from "react";

type PROfileSkillsContainerProps = { id: number };

export const PROfileSkillsContainer: React.FC<PROfileSkillsContainerProps> = ({ id }) => {
  const { data } = useProProfile(id);
  return data ? (
    <PROfileSkills
      data={data.competencies.reduce<Record<string, Array<string>>>((acc, { name, skill }) => {
        if (acc[skill.name]) acc[skill.name].push(name);
        else acc[skill.name] = [name];
        return acc;
      }, {})}
    />
  ) : (
    <PROfileSkillsSkeleton />
  );
};
